import { ChangeEventHandler, useEffect, useRef, useState } from 'react';
import PeopleCounter from './PeopleCounter';
import LevelInput from './LevelInput';
import { Button } from '@/components/ui/button';

export default function PassengerClass({ placeholder, peoples, levels , setFieldValue , maxLength , defaultValue , defaultLevel, shouldOpen }:any) {
  const [showDropdown, setShowDropdown] = useState(false);
  
  // Auto-open effect
  useEffect(() => {
    if (shouldOpen) {
      setShowDropdown(true);
    }
  }, [shouldOpen]);
  const [quantities, setQuantities] = useState([defaultValue.ADULT, defaultValue.CHILD, defaultValue.INFANT]);
  const [activeLevel, setActiveLevel] = useState(defaultLevel || '');
  const dropdownRef:any = useRef(null);

  const handleChangeLevel = (e:any) => {
    setActiveLevel((e.target).value)

    setFieldValue('cabinClass' , e.target.value.toLocaleUpperCase())
  };
  const handleClickBtn = () => setShowDropdown(!showDropdown);

  const formatPeopleString = (passenger:number) => {
    const pluralRules = new Intl.PluralRules();
    const formIndex:any = {
      few: 1,
      many: 2,
      one: 0,
      zero: 2,
    };
  
    const pluralForm = pluralRules.select(passenger);

  
    // Fallback to "many" (plural) if the plural form is unexpected
    const index = formIndex[pluralForm] !== undefined ? formIndex[pluralForm] : 2;
  
    return `${passenger} ${peoples.formats[index]}`;
  };
  

  const updateQuantity = (index: number, newQuantity: any) => {
    const newQuantities = [...quantities];
    const currentTotal = newQuantities.reduce((sum, qty) => sum + qty, 0);
    const proposedTotal = currentTotal - newQuantities[index] + newQuantity;

    // Check if the proposed total exceeds maxLength
    if (proposedTotal > maxLength) {
      return; // Don't update if it would exceed the limit
    }

    newQuantities[index] = newQuantity;

    setFieldValue('paxInfo.ADULT', `${newQuantities[0]}`);
    setFieldValue('paxInfo.CHILD', `${newQuantities[1]}`);
    setFieldValue('paxInfo.INFANT', `${newQuantities[2]}`);
    setQuantities(newQuantities);
  };


  useEffect(() => {
    if (!showDropdown || !dropdownRef) return;
    const handleClickOutside = (e:any) => {
      if (dropdownRef.current && !dropdownRef.current?.contains(e.target)) {
        setShowDropdown(false);
        document.removeEventListener('click', handleClickOutside, true);
      }
    };
    document.addEventListener('click', handleClickOutside, true);
  }, [showDropdown, dropdownRef]);

  return (
    <div ref={dropdownRef} className="relative h-[60px] w-[100%] lg:w-[25%] text-[0.93rem] font-medium border rounded "
>
      <span className="absolute  -top-5 left-4 h-5 text-[0.5625rem] font-semibold   uppercase text-white">{placeholder}</span>
      <button
        type="button"
        className={`flex h-full w-full flex-col justify-center items-start rounded-[10px] bg-white px-4 py-2 text-[0.93rem] font-medium
				after:absolute after:bottom-0	after:right-4 after:top-[5px] after:m-auto after:h-0 after:w-0 after:border-[5px] after:border-transparent after:border-t-[#9ea9b7] focus:shadow-[0_0_0_2px_#ff521f]
				focus:outline-none ${showDropdown ? 'after:-translate-y-1 after:rotate-180' : ''}`}
        onClick={handleClickBtn}
      >
        <span className="leading-5 text-sm text-secondary">
          {formatPeopleString(quantities.reduce((acc, quantity) => (quantity ? acc + quantity : acc), 0))}
        </span>
        <span className="leading-5 text-[#9ea9b7] text-[0.9375]">{activeLevel.replace('_' , " ")}</span>
      </button>
      <div
        className={`absolute right-[-30px] z-10  mt-[2.5px] w-[300px] md:w-[550px] max-h-[550px]  rounded-[5px] bg-white px-5
				py-4 block md:flex md:gap-2 md:divide-x font-[-apple-system,BlinkMacSystemFont,Helvetica,Arial,sans-serif] shadow-[0_6px_9px_rgba(0,0,0,0.08)] transition-opacity
				${!showDropdown ? 'pointer-events-none opacity-0' : 'opacity-100'}`}
      >
        <div className="mb-4 w-full md:w-1/2 last:-mb-2">
          <b className="mb-1 block text-[1.0625rem] font-bold text-secondary">{peoples.title}</b>
          {peoples.data.map((people:any) => (
            <PeopleCounter
              key={people.id}
              id={people.id}
              quantities={quantities}
              range={people.range}
              subtitle={people.subtitle}
              title={people.title}
              onQuantityChange={updateQuantity}
              currentTotal={quantities.reduce((sum, qty) => sum + qty, 0)}
              maxLength={maxLength}
            />
          ))}
        </div>
        {levels ? (
          <div className="mb-4 w-full md:w-1/2 last:-mb-2 md:pl-2">
            <b className="mb-1 block text-[1.0625rem] font-bold text-secondary">{levels.title}</b>
            {levels.data?.map((level:any) => <LevelInput key={level.id} activeLevel={activeLevel} handler={handleChangeLevel} value={level.title} />)}
            <Button className='bg-primary text-white float-right' type="button" onClick={() => setShowDropdown(false)}>Done</Button>

          </div>
        ) : (
          <></>
        )}

      </div>
    </div>
  );
}
